import { Component, inject } from '@angular/core';
import { EleIsService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  EleIsCreateDto,
  EleIsDto,
  EleIsExcelDownloadDto,
  EleIsUpdateDto,
} from '../proxy/planning/dtos/ele-is';
import { ELEIS_CONFIG, ELEIS_FIELDS } from './ele-is.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ele-is',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, EleIsService, ConfirmationService],
  templateUrl: './ele-is.html',
  styleUrl: './ele-is.scss',
})
export class EleIs extends BaseHierarchicalCrudComponent<
  EleIsDto,
  EleIsCreateDto,
  EleIsUpdateDto,
  EleIsExcelDownloadDto
> {
  service = inject(EleIsService);
  config = ELEIS_CONFIG;
  fields = ELEIS_FIELDS;

  protected prepareUpdateDto(data: any, selected: EleIsDto): EleIsUpdateDto {
    return {
      giseleIs: data.giseleIs,
      locationId: data.locationId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'EleIs';
  }
}
